export const SVG_ICONS = [
    {
        key: 'analytic',
        path: '../assets/images/icons/analytic.svg'
    },
    {
        key: 'business-unit',
        path: '../assets/images/icons/business-unit.svg'
    },
    {
        key: 'picture',
        path: '../assets/images/icons/picture.svg'
    },
    {
        key: 'permission',
        path: '../assets/images/icons/permission.svg'
    },
    {
        key: 'organization',
        path: '../assets/images/icons/organization.svg'
    },
    {
        key: 'filter',
        path: '../assets/images/icons/filter.svg'
    },
    {
        key: 'filters',
        path: '../assets/images/icons/filters.svg',
    },
    {
        key: 'inbox',
        path: '../assets/images/icons/inbox.svg'
    },
    {
        key: 'company',
        path: '../assets/images/icons/company.svg'
    },
    {
        key: 'individual',
        path: '../assets/images/icons/individual.svg'
    },
    {
        key: 'item-management',
        path: '../assets/images/icons/item-management.svg'
    },
    {
        key: 'price-book',
        path: '../assets/images/icons/price-book.svg'
    },
    {
        key: 'price-book-id',
        path: '../assets/images/icons/price-book-id.svg'
    },
    {
        key: 'empty',
        path: '../assets/images/icons/illustrations/empty.svg'
    },
    {
        key: 'document-template',
        path: '../assets/images/icons/document-template.svg'
    },
    {
        key: 'document',
        path: '../assets/images/icons/document.svg'
    },
    {
        key: 'view-grid',
        path: '../assets/images/icons/view-grid.svg'
    },
    {
        key: 'view-list',
        path: '../assets/images/icons/view-list.svg'
    },
    {
        key: 'form-mode',
        path: '../assets/images/icons/form-mode.svg'
    },
    {
        key: 'add-table',
        path: '../assets/images/icons/add-table.svg'
    },
    {
        key: 'image',
        path: '../assets/images/icons/image.svg'
    },
    {
        key: 'page-break',
        path: '../assets/images/icons/page-break.svg'
    },
    {
        key: 'text',
        path: '../assets/images/icons/text.svg'
    },
    {
        key: 'embed',
        path: '../assets/images/icons/embed.svg'
    },
    {
        key: 'note',
        path: '../assets/images/icons/note.svg'
    },
    {
        key: 'people',
        path: '../assets/images/icons/people.svg'
    },
    {
        key: 'statistic',
        path: '../assets/images/icons/statistic.svg'
    },
    {
        key: 'bold',
        path: '../assets/images/icons/bold.svg'
    },
    {
        key: 'italic',
        path: '../assets/images/icons/italic.svg'
    },
    {
        key: 'underline',
        path: '../assets/images/icons/underline.svg'
    },
    {
        key: 'active-circle',
        path: '../assets/images/icons/active-circle.svg'
    },
    {
        key: 'inactive-circle',
        path: '../assets/images/icons/inactive-circle.svg'
    },
    {
        key: 'check-circle',
        path: '../assets/images/icons/check-circle.svg'
    },
    {
        key: 'done',
        path: '../assets/images/icons/illustrations/done.svg'
    },
    {
        key: 'signature',
        path: '../assets/images/icons/signature.svg'
    },
    {
        key: 'profile',
        path: '../assets/images/icons/profile.svg'
    },
    {
        key: 'lock',
        path: '../assets/images/icons/lock.svg'
    },
    {
        key: 'building',
        path: '../assets/images/icons/building.svg'
    },
    {
        key: 'erase',
        path: '../assets/images/icons/erase.svg'
    },
    {
        key: 'deal-table',
        path: '../assets/images/icons/deal-table.svg'
    },
    {
        key: 'group-permission',
        path: '../assets/images/icons/group-permission.svg'
    },
    {
        key: 'payment',
        path: '../assets/images/icons/payment.svg'
    },
    {
        key: 'terminal',
        path: '../assets/images/icons/terminal.svg'
    },
    {
        key: 'ticket',
        path: '../assets/images/icons/ticket.svg'
    },
    {
        key: 'duration',
        path: '../assets/images/icons/duration.svg'
    },
    {
        key: 'money',
        path: '../assets/images/icons/money.svg'
    },
    {
        key: 'deposit-amount',
        path: '../assets/images/icons/deposit-amount.svg'
    },
    {
        key: 'access-control',
        path: '../assets/images/icons/access-control.svg'
    },
    {
        key: 'total-volume',
        path: '../assets/images/icons/total-volume.svg'
    },
    {
        key: 'total-deals',
        path: '../assets/images/icons/total-deals.svg'
    },
    {
        key: 'total-commission',
        path: '../assets/images/icons/total-commission.svg'
    },
    {
        key: 'info-outline',
        path: '../assets/images/icons/info-outline.svg'
    },
    {
        key: 'member-group',
        path: '../assets/images/icons/member-group.svg'
    },
    {
        key: 'redoc',
        path: '../assets/images/icons/redoc.svg'
    },
    {
        key: 'pricing-table',
        path: '../assets/images/icons/pricing-table.svg'
    },
    {
        key: 'referral_commision',
        path: '../assets/images/icons/referral-commision.svg',
    },
    {
        key: 'sync_refresh',
        path: '../assets/images/icons/sync-refresh.svg',
    },
];
